// angular
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../core/core.service';

// others
import { AppService } from '../../app.service';
import { AuthService } from '../../core/auth.service';
import { Router } from '@angular/router';
import { BannersService } from './banners.service';
import { concatMap, from, tap } from 'rxjs';
import { MeComponent } from '../me.component';
// import { KlenicoMeService } from '../me.service';
import { finalize } from 'rxjs/operators';
import { KlenicoMeService } from '../me.service';
import * as moment from 'moment';

@Component({
    selector: 'me-banners',
    templateUrl: './banners.component.html',
    styleUrls: ['./banners.component.scss'],
    providers: [BannersService],
    encapsulation: ViewEncapsulation.None
})

export class BannersComponent extends MeComponent implements OnInit {
    @Input() slug : string = '';
    @Input() patientStep : number = 0;
    @Input() srStep : number = 0;
    @Input() card : any;

    url = 'banners';
    urlAPI = 'banners';
    patientId: number;
    data: any;
    banners: any;
    language = this.translate.currentLang;
    form: FormGroup;
    editting: boolean = false;
    submitted: boolean;
    hidePassword = true;
    contents = [];
    showSuccessPage = false;
    colData = {
        left: [],
        right: []
    };

    constructor(
        public appService: AppService,
        public translate: TranslateService,
        public coreService: CoreService,
        public router: Router,
        public bannersService: BannersService,
        public authService: AuthService,
        public meService: KlenicoMeService
    ) {
        super(appService, translate, coreService, router, bannersService, authService);
    }

    ngOnInit() {
        let config = JSON.parse(this.appService.getMeClinicConfig());
        let steps = config?.activeBanners;
        let i = 0;
        this.patientId = this.authService.patientId;
        this.getBannersData();

        if(!steps){
            return;
        }
        from(steps).pipe(
            tap(() => {
                // this.appService.isLoading = true;
            }),
            concatMap(
                step => this.appService.getStoryBlokSlugByUuid(step)
            ),
        ).subscribe( response => {
                this.contents.push(response['story']);
                if(i%2 === 0){
                    this.colData.left.push(response['story']);
                } else{
                    this.colData.right.push(response['story']);
                }
                i++;
            },
            () => {},
            () => {
                this.appService.isLoading = false;
                this.data = this.contents;
                if (!this.data) {
                    this.showSuccessPage = true;
                }
        });
    }

    getBannersData(){
        this.bannersService.getBanners(this.patientId).subscribe(response => {
            this.banners = response;
            this.banners['id'] = this.patientId;
            this.languages = JSON.parse(localStorage.getItem('languages'));
            let form = {};
            this.formLoading = false;
            this.isLoading = false;
        });
    }

    goToSR() {
        this.router.navigate(['me/self-evaluation']);
    }

    // user addition/update handler: send user info to DB
    submit(model: any, isValid: boolean, url?: string, isUpdated?: boolean): void {
        if (url == null) {
            url = this.urlAPI;
        }

        this.resetErrors();
        // this ensures validation messages will only be displayed when necessary
        this.formSubmitted = true;
        // only when the form is valid and its values have been changed
        if (isValid) {
            this.isLoading = true;

            this.meService.submit(url, this.params['id'], model).pipe(
                finalize(() => {
                    this.isLoading = false;
                }))
                .subscribe(
                    response => {
                        this.handleResponse(response);
                    },
                    error => {
                        this.isLoading = false;
                        this.errorMessage = this.appService.parseErrors(error);
                        this.errorData = error?.error?.data || '';
                    }
                );
        }
    }

    logout(){
        if (this.authService.isLoggedIn) {
            this.authService.logout();
            this.router.navigate(['me/login'], {
                queryParams: {
                    infoMessage: 'Your session has expired due to inactivity.'
                }
            });
        }
        localStorage.removeItem('active_time');
    }

    triggerWithCondition(card){
        if(!card){
            return false;
        }
        const slug = card['slug'];
        const trigger = card['content']['trigger'];
        if (card['content']['delay']) {
            let now = moment(moment.utc().format('YYYY-MM-DD hh:mm:ss')).add('1', 'hours'); //Zurich time
            let notification = this.meService.notifications.filter(notication => { return notication.type === trigger})[0];
            if (notification) {
                let validAt = moment(notification.valid_at);
                if (now.diff(validAt, 'minutes') < card['content']['delay']) {
                    return false;
                }
            }
        }

        if (slug.indexOf('process') != -1) {
            return this.meService.TRIGGERS.Login;
        }

        switch (slug) {
            case 'test-user':
                return this.meService.TRIGGERS.Login;
                break;

            case 'net-promoter-score':
                return false;
                break;

            case 'no-show':
                return this.meService.TRIGGERS.NoShow;
                break;

            case 'evaluationreport-explanation':
                return this.meService.TRIGGERS.Document;
                break;

            case 'end-screen':
                return this.meService.TRIGGERS.EvaluationDone && this.meService.nextCreateSr;
                break;

            default:
                return true;
                break;
        }
    }
}
